<template>
	<form action="#" method="post" @submit.prevent="submit">
		<!-- Form Fields -->
		<h2>Agreements</h2>

		<div class="row mt-md-5">
			<div class="col-lg-6">
				<h4 class="pt-4 mb-3">Distribution Reinvestment</h4>
				<div class="form-check radio-checkbox mt-3">
					<input class="form-check-input" type="radio" name="dividends" value="reinvested" id="dividendReinvested" v-model="dividendReinvestment">
					<label class="form-check-label label-lg" for="dividendReinvested">
						<span>I would like my distributions reinvested according to the <a :href="dripLink" target="_blank">Distribution Reinvestment Plan</a>.</span>
					</label>
				</div>
				<div class="form-check radio-checkbox mt-3">
					<input class="form-check-input" type="radio" name="dividends" value="distributed" id="dividendDistributed" v-model="dividendReinvestment">
					<label class="form-check-label label-lg" for="dividendDistributed">
						<span>I would like my distributions deposited to my bank account.</span>
					</label>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="documents-box mt-4 mt-md-5 mt-xl-0">
					<div class="box-icon">
						<img src="./../../assets/icons/document.svg" alt="Document">
					</div>
					<h5 class="text-white">Check out the following documents that are provided for your reference</h5>
					<div class="spinner-border text-white" v-if="!documents.loaded"></div>
					<ol class="documents-list" v-if="documents.loaded">
						<li v-for="document in documents.items" :key="document.id"><a :href="document.url" target="_blank">{{ document.title }}</a></li>
					</ol>
				</div>
			</div>
		</div>

		<hr class="my-5">

		<h4 class="mb-3">Acknowledgement</h4>
		<p>Please indicate agreement with the following:</p>
		<div class="form-check check-checkbox mt-3">
			<input class="form-check-input" type="checkbox" name="privacy" id="agreementPrivacyPolicy" v-model="acknowledgementPrivacy">
			<label class="form-check-label label-lg" for="agreementPrivacyPolicy">
				<span>I have read, understand and hereby consent that by registering for an account an using any of the services I am permitting REITURN to (1) use, store and disclose my personal information in accordance with the <a :href="privacyPolicyLink" target="_blank">Privacy Policy</a> and (2) govern my use of the website according to the <a :href="termsAndConditionsLink" target="_blank">Terms &amp; Conditions</a>.</span>
			</label>
		</div>
		<div class="form-check check-checkbox mt-3">
			<input class="form-check-input" type="checkbox" name="disclosure" id="agreementDisclosure" v-model="acknowledgementInvestmentDisclosure">
			<label class="form-check-label label-lg" for="agreementDisclosure">
				<span>I have read, understand, and agree to be bound by the terms of the REITURN: (1) <a :href="investmentDisclosureLink" target="_blank">Investment Disclosures</a> and <a :href="offeringCircularLink" target="_blank">Offering Circular</a>.</span>
			</label>
		</div>
		<p class="text-danger fw-bolder small mt-3" v-if="showErrors">You must agree to terms listed above.</p>

		<!-- Form Navigation -->
		<div class="d-flex flex-column-reverse flex-md-row justify-content-md-end pt-5">
			<button class="btn btn-outline-dark me-md-2 mt-2 mt-md-0" type="button" @click.prevent="back">Back</button>
			<button class="btn btn-primary btn-wide" type="submit" :disabled="loading">
				<span class="spinner-border" v-if="loading"></span>
				<span v-if="!loading">Continue</span>
			</button>
		</div>
	</form>
</template>

<script>

import repository from "@/repository/repository";
import {PORTAL_URL} from "@/main";
import Logs from "@/repository/logs";

export default {
    name: "AgreementForm",
    beforeMount() {
        // Verify the previous step is completed
        if(!this.$store.getters.bankAccount.completed) {
            this.$router.replace("/details/bank-account");
        }

        // Verify if the current step is finished
        if(this.$store.getters.agreements.finished) {
            this.$router.replace("/review");
        }
    },
	created() {
        repository.get("/documents")
			.then(response => {
                this.documents.items = response.data.documents;
                this.documents.loaded = true;
			})
    },
    data() {
        return {
            dividendReinvestment: this.$store.getters.agreements.dividendReinvestment,
            acknowledgementPrivacy: this.$store.getters.agreements.acknowledgementPrivacy,
            acknowledgementInvestmentDisclosure: this.$store.getters.agreements.acknowledgementInvestmentDisclosure,
            showErrors: false,
			loading: false,
			documents: {
                items: [],
				loaded: false,
			},
        }
    },
    methods: {
        back() {
            this.$store.commit("updateAgreements", {
                dividendReinvestment: this.dividendReinvestment,
                acknowledgementPrivacy: this.acknowledgementPrivacy,
                acknowledgementInvestmentDisclosure: this.acknowledgementInvestmentDisclosure,
            });
            this.$router.back();
        },
        submit() {
            if(!this.checkAgreements()) {
                this.showErrors = true;
                return false;
			}
            this.$store.commit("updateAgreements", {
                dividendReinvestment: this.dividendReinvestment,
                acknowledgementPrivacy: this.acknowledgementPrivacy,
                acknowledgementInvestmentDisclosure: this.acknowledgementInvestmentDisclosure,
            });
            let payload = {
                emailAddress: this.$store.getters.auth.email,
                accountId: this.$store.getters.northCapital.accountId,
                dividendReinvestment: this.$store.getters.agreements.dividendReinvestment,
            };
            repository.post("/agreements", payload)
                .then(response => {
                    console.log(response);
                    this.loading = false;
                    this.$store.commit("finishAgreements");
                    this.$router.push("/review");
                })
                .catch(error => {
                    console.log(error);
                    Logs.save('onboarding.agreementForm', error.response, payload);
                })
        },
		checkAgreements() {
            return (this.acknowledgementPrivacy && this.acknowledgementInvestmentDisclosure);
		},
    },
	computed: {
        termsAndConditionsLink() {
            return PORTAL_URL + "/legal/tos";
        },
        privacyPolicyLink() {
            return PORTAL_URL + "/legal/privacy-policy";
        },
        investmentDisclosureLink() {
            return "https://reiturn.com/investment-disclosure";
        },
        offeringCircularLink() {
            return "https://reiturn.com/offering-circular";
		},
        dripLink() {
            return "https://reiturn.com/drip-plan-agreement";
		},
	},
}
</script>

<style lang="scss">
.form-check.check-checkbox {
	cursor: pointer;
	position: relative;
	padding-left: 2.5rem;

	.form-check-input {
		border-width: 4px;
		width: 1.25rem;
		height: 1.25rem;
		box-shadow: #dcddde 0 0 0 0.15rem;
		border-color: #fff;
		transition: 0.15s ease all;
		float: none;
		position: absolute;
		top: 0.5rem;
		left: 0.15rem;
		margin: 0;

		&:checked {
			box-shadow: #F37021 0 0 0 0.15rem;
			background: #F37021;
			border-color: #fff;
		}
	}

	.form-check-label {
		padding: 0;
		margin: 0;
		display: block;
		cursor: pointer;

		&.label-lg {
			color: #16193A;
			font-size: 1.15rem;

			@media (max-width: 767px) {
				font-size: 1rem;
			}
		}

		strong {
			display: block;
			font-size: 1.15rem;
			font-weight: bold;
			color: #16193A;

			@media (max-width: 767px) {
				font-size: 1rem;
			}
		}

		a {
			color: #F37021;
			font-weight: 600;
		}
	}
}

.documents-box {
	padding: 2rem;
	background: #144069;

	.box-icon {
		width: 3rem;
		height: 3rem;
		line-height: 2.75rem;
		text-align: center;
		background: #fff;
		border-radius: 50%;

		img {
			width: 1rem;
		}
	}

	h5 {
		margin: 1rem 0;
	}

	.documents-list {
		color: rgba(255,255,255,0.25);
		font-size: 1.15rem;
		padding-left: 1.25rem;
		margin: 0;

		li {
			margin-top: 0.25rem;
		}

		a {
			color: rgba(255,255,255,0.65);
			text-decoration: none;
			display: block;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			transition: 0.15s ease all;

			&:hover {
				color: #fff;
			}
		}
	}
}
</style>